/*
 * @Description:
 * @Author: FengXiao
 * @Date: 2020-01-13 17:48:40
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-06 22:52:16
 */
function transformRequest(data) {
  const res = [];
  for (const key in data) {
    res.push(`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}&`);
  }
  return res.join('');
}
function getDateTime() {
  const date = new Date();
  const year = date.getFullYear();
  let month = date.getMonth() + 1;
  if (month < 10) {
    month = `0${month}`;
  }
  let day = date.getDate();
  if (day < 10) {
    day = `0${day}`;
  }
  const dateStr = `${year}-${month}-${day}`;
  const timeStr = date.toTimeString().split(' ')[0];
  const list = ['日', '一', '二', '三', '四', '五', '六'];
  const weekStr = `周${list[date.getDay() - 1]}`;
  return {
    date: dateStr,
    time: timeStr,
    week: weekStr,
  };
}
//千分位标记
function thousandsMark(n) {
  const re = /\d{1,3}(?=(\d{3})+$)/g;
  const n1 = n.toString().replace(/^(\d+)((\.\d+)?)$/, function(s, s1, s2) {
    return s1.replace(re, '$&,') + s2;
  });
  return n1;
}
function setCityPosition(cityName) {
  const positionList = {
    合肥: 'left',
    芜湖: 'bottom',
    常州: 'top',
    淮安: 'top',
    无锡: [6, -14],
    台州: 'bottom',
    佛山: 'left',
    中山: 'bottom',
    苏州: 'bottom',
    马鞍山: 'bottom',
    泰州: 'top',
    宁波: 'bottom',
    广州: 'top',
    绍兴: 'left',
  };
  if (positionList[cityName]) {
    return positionList[cityName];
  }
  return 'right';
}

function getRad(d) {
  const PI = Math.PI;
  return (d * PI) / 180.0;
}
function getDistance(lat1, lng1, lat2, lng2) {
  var f = getRad((lat1 + lat2) / 2);
  var g = getRad((lat1 - lat2) / 2);
  var l = getRad((lng1 - lng2) / 2);
  var sg = Math.sin(g);
  var sl = Math.sin(l);
  var sf = Math.sin(f);
  var s, c, w, r, d, h1, h2;
  var a = 6378137.0;
  var fl = 1 / 298.257;
  sg = sg * sg;
  sl = sl * sl;
  sf = sf * sf;
  s = sg * (1 - sl) + (1 - sf) * sl;
  c = (1 - sg) * (1 - sl) + sf * sl;
  w = Math.atan(Math.sqrt(s / c));
  r = Math.sqrt(s * c) / w;
  d = 2 * w * a;
  h1 = (3 * r - 1) / 2 / c;
  h2 = (3 * r + 1) / 2 / s;
  s = d * (1 + fl * (h1 * sf * (1 - sg) - h2 * (1 - sf) * sg));
  s = s / 1000;
  s = s.toFixed(2);
  return s;
}

function checkEquipment() {
  const ua = navigator.userAgent.toLowerCase();
  
  // 检测鸿蒙（新旧版本、纯血版本）+ 其他移动端
  const isMobileDevice = /android|iphone|ipod|ipad|windows phone|harmonyos|openharmony|ohos|micromessenger/i.test(ua);
  
  // 检测 iPad Pro
  const isIPadPro = /macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
  
  // 小屏幕检测
  const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
  
  // 最终判断
  if ((isMobileDevice || isIPadPro) && isSmallScreen) {
    // 防止无限重定向
    if (!sessionStorage.getItem('h5_redirect')) {
      sessionStorage.setItem('h5_redirect', '1');
      window.location.href = `${process.env.VUE_APP_URL}/wx/h5/`;
    }
    return false;
  }
  return true;
}

export { transformRequest, getDateTime, thousandsMark, setCityPosition, getDistance, checkEquipment };
